import OAuthCallback from '../OAuthCallback.jsx';

const ZoomOAuthCallback = ({}) => {
    return <OAuthCallback route="/api/integrations/zoom/oauth" />;
};

export default ZoomOAuthCallback;
